// * MUI Components
import { Box, Container, Typography, styled } from "@mui/material";
import { Person, Code } from "@mui/icons-material";
import ShapeBackground from "./fancy/ShapeBackground";

// * MUI Styled Components
const CustomBoxCtn = styled(Container)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  padding: theme.spacing(8, 2),
  [theme.breakpoints.down("md")]: {
    padding: theme.spacing(6, 2),
  },
}));

export default function Reviews() {
  return (
    <Box sx={{ position: "relative", overflow: "hidden", py: 4 }}>
      <ShapeBackground />
      <CustomBoxCtn sx={{ position: "relative", zIndex: 1 }}>
        <Box
          sx={{
            width: 120,
            height: 120,
            borderRadius: "50%",
            backgroundColor: "#E6F0FF",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: 3,
          }}
        >
          <Person sx={{ fontSize: 60, color: "#3370FF" }} />
        </Box>

        <Typography
          variant="h3"
          sx={{
            fontSize: "35px",
            fontWeight: "bold",
            color: "#2B3674",
            mb: 3,
          }}
        >
          The Team
        </Typography>

        <Box sx={{ maxWidth: "700px", mb: 4 }}>
          <Typography
            sx={{
              fontSize: "18px",
              color: "#2B3674",
              lineHeight: 1.8,
              mb: 3,
            }}
          >
            Dizpurse is built by engineers with experience in startups and fintech.
          </Typography>
          <Typography
            sx={{
              fontSize: "16px",
              color: "#4A5568",
              lineHeight: 1.8,
            }}
          >
            We're building the tool we wished existed—automated money management that actually works. Simple rules, automatic transfers, and smart savings without the complexity.
          </Typography>
        </Box>

        <Box sx={{ display: "flex", gap: 3, alignItems: "center", flexWrap: "wrap" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Code sx={{ color: "#3370FF" }} />
            <Typography sx={{ color: "#4A5568", fontSize: "14px" }}>
              Software Engineering
            </Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Person sx={{ color: "#3370FF" }} />
            <Typography sx={{ color: "#4A5568", fontSize: "14px" }}>
              Startup Experience
            </Typography>
          </Box>
        </Box>
      </CustomBoxCtn>
    </Box>
  );
}
